import { render } from "./OrderOneStrykerKpi.vue?vue&type=template&id=58d05a27"
import script from "./OrderOneStrykerKpi.vue?vue&type=script&lang=js"
export * from "./OrderOneStrykerKpi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__